/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { useRouterStoreActions } from '../router-store/index.tsx';
import type { RouterActionsType } from '../router-store/types.tsx';

/**
 * Hook for accessing the public router store without re-rendering on route change
 *
 * Note that this should eventually filter out private state / actions
 */
export const useRouterActions: () => RouterActionsType = () => useRouterStoreActions();
